/**
 * Storec-wide routes where UI translation and the language switcher are always available
 * (Welcome, Login, admin management — not tied to a store's multiLanguageEnabled setting).
 *
 * @param {string} pathname
 * @returns {boolean}
 */
const isGlobalAppLanguageRoute = (pathname) => {
    if (!pathname) {
        return false;
    }

    if (pathname === '/' || pathname === '/login') {
        return true;
    }

    return pathname.startsWith('/administration');
};

export default isGlobalAppLanguageRoute;
